<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KhFk9t/tc-custom/9781460323755.jpg?1704296330171" alt="This image is the cover for the book Hunted, The Profiler"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hunted, The Profiler
      </h1>
      <p class="bookDescription body article font2">
        <b>An FBI profiler plays a deadly game of cat and mouse with a twisted serial killer in this “terrific, gripping, page-turning” thriller series debut (<i>New York Times</i>–bestselling author Allison Brennan).</b><br/><br/>FBI profiler Evelyn Baine knows how to think like a serial killer. But she’s never chased anyone like the Bakersville Burier, who displays his female victims, half-buried, deep in the woods of a small Virginia town. As the body count climbs, Evelyn’s relentless pursuit of the killer puts her career—and her life—at risk. And the evil lurking in the Burier’s mind may be more than even she can unravel.<br/><br/>The Bakersville Burier knows that Evelyn is closing in on him. But he also knows exactly where to find her. For now, he’s biding his time, because he’s planned a special punishment for Evelyn. She may have tracked other killers, but he vows to make this her last chase. This time it’s <i>her</i> turn to be hunted!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Heiter
      </h2>
      
      <p class="authorDescription body article"><I>Publishers Weekly </I>bestselling and award-winning author ELIZABETH HEITER likes her suspense to feature strong heroines, chilling villains, psychological twists and a little romance. Her research has taken her into the minds of serial killers, through murder investigations, and onto the FBI Academy&rsquo;s shooting range. Her novels have been published in more than a dozen countries and translated into eight languages. Visit her at www.elizabethheiter.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a2955a9